import React from 'react';

import Container from 'legacy/common/components/layout/Container';

const PageSkeleton = () => (
  <>
    <div className="animate-pulse h-[60px] -mt-[10px] w-full bg-gray-200" />
    <div className="animate-pulse pt-[90px] md:pt-[40px] pb-20 md:w-[730px] md:mx-auto flex flex-col items-center">
      <Container>
        <div className="h-[20px] w-[200px] bg-gray-200 rounded-xl" />
        <div className="mt-6 h-[70px] w-full bg-gray-200 rounded-xl" />
        <div className="mt-6 h-[70px] w-full bg-gray-200 rounded-xl" />
      </Container>
    </div>
  </>
);

export default PageSkeleton;
